export default {
  SET_MY_ORGANIZATION(state, data) {
    state.myOrganization = {
      ...data,
    }
  },
  UPDATE_MY_ORGANIZATION(state, data) {
    state.myOrganizationUpdate = data
  },
  LIST(state, data) {
    state.list = data
  },
  FRESH(state) {
    state.settings = {}
  },
  UPDATE(state, data) {
    state.settings = { ...data }
  },
}
